import React, { Component } from 'react';
import '../../../App.css';
import '../../../styles/app-demo.css';

class SelectPayee extends Component {

  render() {

    return (
      <div className="fintwist-interactive-mobile">
        <section className="mobile-app-wrapper">
          <div className="orange-header">
            <i onClick={() => this.props.handleBillPayRoute('home')} className="fa fa-angle-left"></i>
            <h2>Select Payee</h2>
          </div>
        <div className="mobile-app-dashboard">
          <div className="mobile-app-dashboard">
            <div className="list-header">
              <p>My Payees</p>
            </div>
            <ul className="app-list">
              <li onClick={() => this.props.handleBillPayRoute('pay amount')} >
                <div className="app-list-row-1">
                  <p>Sheffield Financial...</p>
                </div>
              </li>
            </ul>
          </div>
          </div>
        </section>
      </div>
    );
  }
}

export default SelectPayee;
